export { default as DepositsPage } from './Deposits/deposits-page';
export { default as DepositDetailsPage } from './DepositDetails/deposit-details-page';
